import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { Funcoes } from "../funcoes";
import { Global } from "../global";
import { BasicValidators } from "../shared/basic-validators";
import { LaudosPdfModel } from "./laudos-pdf.model";
import { LaudosPdfService } from "./laudos-pdf.service";
import { ClientesService } from "../clientes/clientes.service";
import { MercadoriasService } from "../mercadorias/mercadorias.service";
import { TiposClientesService } from "../clientes/tipos-clientes.service";
import { UnidadesService } from "../unidades/unidades.service";
import { TerminaisService } from "../terminais/terminais.service";


@Component({
  selector: 'app-laudos-pdf-form',
  templateUrl: './laudos-pdf-form.component.html'
})
export class LaudosPdfFormComponent implements OnInit {

  form: FormGroup;
  title: string;
  laudo: LaudosPdfModel = new LaudosPdfModel();
  pageIsUpd: boolean = false;
  pageIsAdd: boolean = false;

  listClientes = [];
  listMercadorias = [];
  listTerminal = [];
  listUnidades = [];

  comPDF: boolean = false;
  id_laudo: any;

  url = '';
  alturaTela;

  mascaraContainer = [/[a-zA-Z]/, /[a-zA-Z]/, /[a-zA-Z]/, /[a-zA-Z]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
  enviando = false;

  getUrlPdf(id_laudo: any): string {
    return this.global.dominio_site + '/adm/fichas/laudos-pdf/' + id_laudo + '/pdf/?tk=' + localStorage.getItem('token') + '&t=' + new Date().getTime();
  }

  constructor(
    formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private laudosService: LaudosPdfService,
    private clientesService: ClientesService,
    private mercadoriasService: MercadoriasService,
    private tiposClientesService: TiposClientesService,
    private unidadesService: UnidadesService,
    private terminaisService: TerminaisService,
    private _location: Location,
    public func: Funcoes,
    public global: Global
  ) {

    route.params.subscribe(params => {
      this.id_laudo = params['id_laudo'];

      if (this.id_laudo) {
        this.url = this.getUrlPdf(this.id_laudo);

        this.laudosService.existePDF(this.id_laudo)
          .subscribe(
            json => {
              this.comPDF = true;
            },
            error => {

            });
      }
    });

    this.alturaTela = window.screen.availHeight - 250;

    this.form = formBuilder.group({
      id_laudo: [],
      id_cliente: ['', [
        Validators.required,
        BasicValidators.notNull
      ]],
      id_unidade: ['', [
        Validators.required,
        BasicValidators.notNull
      ]],
      id_terminal: ['', [
        Validators.required,
        BasicValidators.notNull
      ]],
      id_mercadoria: ['', [
        Validators.required,
        BasicValidators.notNull
      ]],
      data: ['', [
        Validators.required
      ]],
      referencia: [],
      fatura: [],
      container: ['', [
        BasicValidators.containerNumber
      ]],
      conhecimento: [],
      numero: [],
      id_status: [],
      pdf: []
    });

    // busca clientes por tipo
    this.tiposClientesService.get(["clientes"])
      .subscribe(
        json => {
          //this.ficha = json.Payload;


          for (let x in json.Payload) {
            switch (json.Payload[x].id_tipo) {
              case "1":
                this.listClientes = this.func.mergeObjByProp(this.listClientes, json.Payload[x].clientes, 'id_cliente');
                break;

              case "2":
                this.listClientes = this.func.mergeObjByProp(this.listClientes, json.Payload[x].clientes, 'id_cliente');
                break;

              case "6":
                this.listClientes = this.func.mergeObjByProp(this.listClientes, json.Payload[x].clientes, 'id_cliente');
                break;
              default:
                break;
            }
          }

        },
        error => {
          this.func.showErro(error.json());
        });

    // busca terminais
    this.terminaisService.get()
      .subscribe(
        json => {
          this.listTerminal = json.Payload;
        },
        error => {
          this.func.showErro(error.json());
        });

    this.mercadoriasService.get(null, null, ['id', 'nome_padrao'])
      .subscribe(
        json => {
          this.listMercadorias = json.Payload;
        },
        error => {
          this.func.showErro(error.json());
        });

    // busca unidades
    this.unidadesService.get()
      .subscribe(json => {
        this.listUnidades = json.Payload;
      });

  }

  ngOnInit() {

    // verifica se é uma página de edição
    if (this.router.url.split(/\//).pop() == 'upd') {
      this.pageIsUpd = true;
    }

    // verifica se é uma página para adicionar
    if (this.router.url.split(/\//).pop() == 'add') {
      this.pageIsAdd = true;
    }

    let id = this.route.params.subscribe(params => {
      let id = params['id_laudo'];

      if (!this.pageIsUpd) {
        this.title = this.func.traduzir('front.editarLaudoPdf');
      } else {
        this.title = id ? this.func.traduzir('front.visualizarLaudoPdf') : this.func.traduzir('front.cadastrarNovoLaudoPdf');
      }

      if (!id) {
        return;
      }

      this.laudosService.getById(id)
        .subscribe(
          json => {
            if (this.global.debug == true) {
              console.log(json.Payload[0]);
            }

            if (this.pageIsUpd) {
              this.title = this.func.traduzir('front.editarLaudoPdf') + ': ' + json.Payload[0].descricao;
            } else {
              this.title = this.func.traduzir('front.visualizarLaudoPdf') + ': ' + json.Payload[0].descricao;
            }
            this.laudo = json.Payload[0];
          },
          error => {
            this.func.showErro(error.json());
          });
    });
  }

  voltar() {
    this._location.back();
  }

  save() {

    this.enviando = true;

    let result,
      values = this.laudo; //this.form.value;

    if (values.id_laudo) {
      result = this.laudosService.editar(values, values.id_laudo);
      result.subscribe(data => this.router.navigate(['/painel', 'fichas', 'laudos-pdf']),
        error => {
          this.enviando = false;
          this.func.showErro(error.json());
        });

    } else {
      result = this.laudosService.adicionar(values);
      result.subscribe(data => this.router.navigate(['/painel', 'fichas', 'laudos-pdf', data.Payload, 'upd']),
        error => {
          this.enviando = false;
          this.func.showErro(error.json());
        });

    }

  }

  uploadPDFComplete(resp) {
    try {
      let json = typeof resp === 'string' ? JSON.parse(resp) : resp;

      if (json && json.Success) {
        this.func.showSucesso(json.Message);

        let id = this.id_laudo || this.laudo.id_laudo;
        this.comPDF = false;
        this.url = '';

        setTimeout(() => {
          if (id) {
            this.url = this.getUrlPdf(id);
          }
          this.comPDF = true;
        }, 100);

      } else {
        this.func.showErro(json);
      }

    }
    catch (e) { }
  }

  // evento quando o container é alterado
  changeContainer(e) {
    this.laudo.container = e.toUpperCase();
  }
}



// WEBPACK FOOTER //
// ./src/app/laudos-pdf/laudos-pdf-form.component.ts